import { render, staticRenderFns } from "./Trucks.vue?vue&type=template&id=61d06ff4&scoped=true"
import script from "./Trucks.vue?vue&type=script&lang=ts"
export * from "./Trucks.vue?vue&type=script&lang=ts"
import style0 from "./Trucks.vue?vue&type=style&index=0&id=61d06ff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d06ff4",
  null
  
)

export default component.exports